import styled from 'styled-components'

export const ModalBody = styled.div`
  padding: 15px;
`

export const ModalTextContent = styled.div`
`

export const ModalText = styled.p`
  font-size: 1rem;
`
export const ModalFooter = styled.div`
  border-top: 1px solid #C4C4C4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
`
